import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-komitent-ugovor-stavka-update-container',
  templateUrl: './komitent-ugovor-stavka-update-container.component.html'
})
export class KomitentUgovorStavkaUpdateContainerComponent<T extends BaseEntity> extends BaseInlineContainer<T> implements OnInit {

  constructor(
   protected  inlineContainerService: InlineContainerService<T>,
   protected activatedRoute: ActivatedRoute,
   protected userService: UserService
  ) { 
    super(inlineContainerService, activatedRoute, userService)
  }

  tempItems: List<T>

setItems(items) {
this.tempItems = items;
}
  ngOnInit() {
    super.ngOnInit();
  }

}
